var _style, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Tag-st0{fill:currentColor;}\r\n\t.Tag-st1{fill:currentColor;stroke:currentColor;stroke-miterlimit:10;}\r\n\t.Tag-st2{fill:currentColor;stroke:currentColor;stroke-width:5.000000e-02;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Tag-st0",
    d: "M3.5,7.1C1.6,7.1,0,5.5,0,3.5S1.6,0,3.5,0s3.5,1.6,3.5,3.5S5.5,7.1,3.5,7.1z M3.5,0.9c-1.5,0-2.7,1.2-2.7,2.7 c0,1.5,1.2,2.7,2.7,2.7C5,6.2,6.2,5,6.2,3.5C6.2,2.1,5,0.9,3.5,0.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Tag-st0",
    d: "M20.5,7.1c-2,0-3.5-1.6-3.5-3.5S18.5,0,20.5,0S24,1.6,24,3.5S22.4,7.1,20.5,7.1z M20.5,0.9 c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C23.1,2.1,21.9,0.9,20.5,0.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Tag-st0",
    d: "M3.5,24c-2,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S5.5,24,3.5,24z M3.5,17.8 c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C6.2,19,5,17.8,3.5,17.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Tag-st0",
    d: "M20.5,24c-2,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5S22.4,24,20.5,24z M20.5,17.8 c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.7C23.1,19,21.9,17.8,20.5,17.8z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "Tag-st1",
    x1: 6.8,
    y1: 3.5,
    x2: 17.2,
    y2: 3.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "Tag-st1",
    x1: 6.8,
    y1: 20.5,
    x2: 17.2,
    y2: 20.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "Tag-st1",
    x1: 20.5,
    y1: 6.8,
    x2: 20.4,
    y2: 17.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "Tag-st1",
    x1: 3.5,
    y1: 6.5,
    x2: 3.5,
    y2: 17.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Tag-st2",
    d: "M17.9,12.2L13,7.3c-0.1-0.1-0.3-0.2-0.5-0.2H7.6c-0.4,0-0.7,0.3-0.7,0.7v4.9c0,0.2,0.1,0.4,0.2,0.5L12,18 c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.4-0.1,0.5-0.2l4.9-4.9C18.1,12.9,18.1,12.4,17.9,12.2z M10.4,12C9.6,12,9,11.3,9,10.6 c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S11.2,12,10.4,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.5a90ae3cdc340d20e55d5d16fbdae445.svg";
export { ForwardRef as ReactComponent };